import { render, staticRenderFns } from "./GridAdmin.vue?vue&type=template&id=3d36f6ca&scoped=true&"
import script from "./GridAdmin.vue?vue&type=script&lang=js&"
export * from "./GridAdmin.vue?vue&type=script&lang=js&"
import style0 from "./GridAdmin.vue?vue&type=style&index=0&id=3d36f6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d36f6ca",
  null
  
)

export default component.exports